import React, { useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
// import { getPetSize, getPetAge } from '../../services/helpers'
import { api } from '../../services/api'
import { NotesTable } from '../../components/Tables/NotesTable'
import moment from 'moment'
import { getVisitsByFacilityId } from '../../actions/visits/visits.actions'
import {
	Button,
	Link,
	Typography,
	useTheme,
	Menu,
	ListItemText,
	CircularProgress,
	MenuItem
} from '@material-ui/core'
// import { cloneDeep } from 'lodash'
import { Link as RouterLink } from 'react-router-dom'
// import KennelBlockDialogNew from '../../components/Dialogs/KennelBlockDialogNew'
// import { updateKennelAssignment } from '../../actions/kennels/kennels.actions'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks'
const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	bottomBar: {
		position: 'fixed',
		bottom: 0,
		width: '50%',
		height: 60,
		background: '#FFF',
		border: '1px solid #D0CFD2',
		borderLeftWidth: 0,
		borderTopRightRadius: 6,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: 20,
		'& i': {
			marginRight: 17,
			cursor: 'pointer',
			color: '#D0CFD2'
		},
		'& .whee': {
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 16,
			color: '#1A1A35',
			marginRight: 17
		},
		'& .checked': {
			color: '#6B4AD6'
		},
		'& .selectedFacility': {
			marginLeft: 10,
			fontSize: 16,
			color: '#6B4AD6 !important',
			textTransform: 'uppercase',
			fontFamily: 'Nunito',
			fontWeight: 'bold'
		}
	},
	changeButton: {
		padding: 0,
		'&:hover': {
			background: 'transparent'
		}
	},
	label: {
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '22px',
		letterSpacing: '0px',
		textAlign: 'left',
		textTransform: 'none',
		color: theme.palette.secondary.main
	},
	menu: {
		paddingLeft: 0,
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: '#3B0275',
			opacity: 0.6
		}
	},
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	},
	description: {
		color: '#777679',
		fontSize: 14,
		fontWeight: '600'
		// marginBottom: 8,
	},
	date: {
		color: '#a2a1a4',
		fontSize: 14,
		fontWeight: '600'
	},
	noteRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		cursor: 'pointer'
	},
	noteTitle: {
		fontSize: 16,
		color: '#6B4AD6',
		fontWeight: '800',
		marginRight: 8,
		textTransform: 'capitalize',
		marginLeft: 8,
		minWidth: 82,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	noteType: {
		fontSize: 16,
		color: '#6B4AD6',
		fontWeight: '600',
		marginRight: 10,
		textTransform: 'capitalize'
	},
	noteTags: {
		fontSize: 16,
		color: '#777679',
		fontWeight: '600',
		marginRight: 6,
		textTransform: 'capitalize',
		width: 285,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	},
	note: {},
	descriptionParagraph: {
		margin: 0
	}
}))

const StaffNotes = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const theme = useTheme()

	const facility = useSelector((state) => state.specific.facilities.selected)
	const [selectedFilters, selectFilters] = useState([])
	const visits = useSelector((state) => state.specific.visits.visits)
	const pets = useSelector((state) => state.specific.visits.pets)
	const [loading, setLoading] = useState(false)
	// const playgroups = (facility && facility.playgroups) || []
	const [search, setSearch] = useState('')
	const [date, setDate] = useState(moment().format('YYYY-MM-DD'))
	const [data, setData] = useState([])
	// const [isKennelBlockPopupShown, setIsKennelBlockPopupShown] = useState(false)
	// const [pet, setPet] = useState(null)

	const setFilters = (filts) => {
		selectFilters(filts)
	}

	const getNoteTags = (note) => {
		if (note.tags && note.tags.length) {
			let j = note.tags.join(', ')
			let r = j.replace(/_/g, ' ')
			return r
		}
		return ''
	}

	const getNoteTitle = (note) => {
		if (note.title) return note.title
		return 'Staff Note'
	}

	const getNoteType = (note) => {
		return note.type
	}

	const getColor = (note) => {
		if (note.tags && note.tags.includes('raise_alert')) return '#DC2A2A'
		return '#E5B35B'
	}

	// @TODO not being used?
	// const getNoteStatus = (note) => {
	// 	return note.status || 'Open'
	// }

	const renderDescription = useCallback((description) => {
		const paragraphs = description.split('\n')
		if (paragraphs.length < 2) {
			return description
		}

		const formatted = paragraphs.map((line) => <p className={classes.descriptionParagraph}>{line}</p>)
		return formatted
	}, [])

	const renderRow = (row) => {
		let color = getColor(row)
		return (
			<div className={classes.note}>
				<div
					className={classes.noteRow}
					onClick={(e) => {
						e.stopPropagation()
						let url =
							process.env.REACT_APP_ENV === 'production'
								? 'https://admin-petcare.herokuapp.com'
								: 'https://admin-petcare-staging.herokuapp.com'
						window.open(
							`${url}/clients/${row.household._id}/appointments/${row.visit._id}?noteID=${row._id}`,
							'_blank'
						)
					}}>
					<div
						style={{
							height: 16,
							backgroundColor: color,
							width: 4,
							borderRadius: 4
						}}></div>
					<Typography className={classes.noteTitle}>{getNoteTitle(row)}</Typography>
					<Typography className={classes.noteType}>{getNoteType(row)}</Typography>
					<Typography className={classes.noteTags}>{getNoteTags(row)}</Typography>
				</div>
				<Typography className={classes.description}>{renderDescription(row.description || '')}</Typography>
				<Typography className={classes.date}>{moment(row.createdAt).format('MMM D, h:mma')}</Typography>
			</div>
		)
	}

	const getColumns = () => {
		return [
			{
				title: 'Status',
				render: (data) => renderStatus(data),
				width: 210
			},
			{
				title: 'Details',
				render: (data) => renderRow(data),
				width: 460,
				cellStyle: {
					paddingRight: 0,
					paddingLeft: 0
				}
			},
			{
				title: 'Pet',
				render: (data) => renderPet(data),

				customFilterAndSearch: (value, rowData) => {
					let name = value
					if (name) name = name.toUpperCase()

					let primary =
						rowData.household.accounts && rowData.household.accounts.length
							? rowData.household.accounts.find((a) => a.primary)
							: null

					let petName = `${rowData.pet.name}${primary ? ` ${primary.last_name}` : ''}`

					return petName.toUpperCase().includes(name)
				}
			},
			{
				title: 'Appointment',
				render: (data) => renderAppt(data),
				width: 245
			}
		]
	}

	const getDate = (data) => {
		// console.log("data");
		let start = moment(data.visit.startDate)
		let end = moment(data.visit.endDate)
		if (start.isSame(end, 'month')) return `${start.format('MMM D')} - ${end.format('D')}`
		return `${start.format('MMM DD')} - ${end.format('MMM DD')}`
	}

	const renderDates = (data) => <Typography variant="body2">{getDate(data)}</Typography>

	const renderStatus = (data) => {
		return <Status note={data} changeStatus={changeStatus} loading={loading} />
	}

	const changeStatus = async (n) => {
		try {
			setLoading(n._id)

			let { data } = await api.put(`/updateStaffNote`, n)
			console.log('data...', data)
			dispatch({ type: 'UPDATE_NOTE_LIST', payload: n })

			setTimeout(() => {
				setLoading(null)
			}, 300)
		} catch (e) {
			console.log('error...', e)
			setLoading(false)
		}
	}

	const renderAppt = (data) => {
		let { visit } = data
		if (!visit) return null
		return (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column'
				}}>
				<Link
					component={RouterLink}
					style={{
						color: '#6B4AD6',
						fontSize: 16,
						textTransform: 'capitalize'
					}}
					onClick={(e) => {
						e.stopPropagation()
						let url =
							process.env.REACT_APP_ENV === 'production'
								? 'https://admin-petcare.herokuapp.com'
								: 'https://admin-petcare-staging.herokuapp.com'
						window.open(
							`${url}/clients/${data.household._id}/appointments/${data.visit._id}`,
							'_blank'
						)
					}}>
					{visit.type}{' '}
					{visit.type === 'boarding' ? getDate(data) : moment(visit.startDate).format('MMM D')}{' '}
				</Link>
				<Typography variant="body1" style={{ color: '#777679', fontSize: 14 }}>
					{visit.status.name}
				</Typography>
			</div>
		)
	}

	const renderPet = (data) => {
		if (!data.household) console.log('data....', data)
		let primary =
			data?.household?.accounts && data?.household?.accounts.length
				? data.household.accounts.find((a) => a.primary)
				: null

		return (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column'
				}}>
				<Link
					component={RouterLink}
					style={{
						color: theme.palette.secondary.main,
						marginBottom: 5,
						fontSize: '16px',
						lineHeight: '22px'
					}}
					onClick={(e) => {
						e.stopPropagation()
						let url =
							process.env.REACT_APP_ENV === 'production'
								? 'https://admin-petcare.herokuapp.com'
								: 'https://admin-petcare-staging.herokuapp.com'
						window.open(`${url}/clients/${data.household._id}/pets/${data.pet_id}`, '_blank')
					}}>
					{`${data.pet.name}${primary ? ` ${primary.last_name}` : ''}`}
				</Link>
			</div>
		)
	}

	const types = ['General', 'Health', 'Meal', 'Behavior', 'Kenneling', 'Incident']

	useEffect(() => {
		dispatch({ type: 'CLEAR_VISITS' })
	}, [])

	useEffect(() => {
		if (facility) {
			dispatch(getVisitsByFacilityId(facility, date))
		}
	}, [date, facility])

	useEffect(() => {
		if (pets && visits) {
			let notes = []
			visits.forEach((v, i) => {
				if (v.staff_notes && v.staff_notes.length) {
					v.staff_notes.forEach((note) => {
						// console.log('note...', note)
						if (moment(note.createdAt).isSame(moment(date), 'day')) {
							let pet = pets.find((p) => p._id === note.pet_id)
							let noter = {
								...note,
								pet: pet,
								household: (v && v.household) || {},
								visit: v
							}
							notes.push(noter)
						}
					})
				}
			})

			const filterObj = {
				Open: (n) => !n.status || n.status === 'Open',
				'In Progress': (n) => n.status === 'In Progress',
				Closed: (n) => n.status === 'Closed',
				raise_alert: (n) => n?.tags?.includes('raise_alert'),
				check_out: (n) => n?.tags?.includes('check_out'),
				client_comment: (n) => n?.tags?.includes('client_comment'),
				staff_note: (n) => n.type === 'Staff Note' || types.includes(n.type) || !n.type,
				meal_alert: (n) => n.type === 'Alert' && n.alert_type === 'meal',
				body_check_alert_entry: (n) => n.type === 'Alert' && n.alert_type === 'body_check' && n.entry,
				body_check_alert_exit: (n) => n.type === 'Alert' && n.alert_type === 'body_check' && n.exit,
				addon_alert: (n) => n.type === 'Alert' && n.alert_type === 'addon',
				boarding: (n) => n?.visit?.type === 'boarding',
				daycare: (n) => n?.visit?.type === 'daycare',
				compatibility_session: (n) => n?.visit?.type === 'compatibility_session',
				2: (n) => n?.visit?.status?.id === 2,
				4: (n) => n?.visit?.status?.id === 4,
				5: (n) => n?.visit?.status?.id === 5
			}

			if (selectedFilters.length) {
				let f = selectedFilters.map((sf) => sf.value)
				notes = notes.filter((note) =>
					selectedFilters.some((f) => !filterObj[f.value] || filterObj[f.value](note))
				)
			}

			setData(notes)
		}
	}, [pets, visits, selectedFilters])

	const changeDate = (type) => {
		if (type === 'add') {
			setDate(moment(date).add(1, 'd').format('YYYY-MM-DD'))
		} else if (type === 'subtract') {
			setDate(moment(date).subtract(1, 'd').format('YYYY-MM-DD'))
		}
	}

	return (
		<div className={classes.root}>
			{facility ? (
				<div className={classes.visitsTableContainer}>
					<NotesTable
						data={data}
						columns={getColumns()}
						date={date}
						changeDate={changeDate}
						setDate={setDate}
						setFilters={setFilters}
						selectedFilters={selectedFilters}
						search={search}
						setSearch={setSearch}
					/>
				</div>
			) : (
				<h3>Please Select a Facility</h3>
			)}
		</div>
	)
}

export default StaffNotes

const Status = (props) => {
	const classes = useStyles()
	const popupState = usePopupState({
		variant: 'popover',
		popupId: 'facilityMenu'
	})
	const stati = ['Open', 'In Progress', 'Closed']
	return (
		<div>
			<Button
				{...bindTrigger(popupState)}
				style={{
					backgroundColor: '#F3F3F3',
					color: '#4D4C4F',
					fontSize: 14,
					fontWeight: '600',
					height: 25,
					borderRadius: 4,
					paddingLeft: 14,
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'noWrap'
				}}>
				{props.note.status || 'Open'}
				{props.loading === props.note._id ? <CircularProgress size={16} /> : <ArrowDropDownIcon />}
			</Button>
			<Menu {...bindMenu(popupState)}>
				{stati.map((s) => {
					return (
						<MenuItem
							className={classes.listItem}
							onClick={() => {
								if (s === props.note.status) {
									popupState.close()
									return
								}
								props.changeStatus({
									...props.note,
									visit_id: props.note.visit_id,
									status: s
								})
								popupState.close()
							}}>
							<ListItemText primary={s} />
						</MenuItem>
					)
				})}
			</Menu>
		</div>
	)
}
